import { render, staticRenderFns } from "./FornecedorManage.vue?vue&type=template&id=52f18aa5&scoped=true"
import script from "./FornecedorManage.vue?vue&type=script&lang=js"
export * from "./FornecedorManage.vue?vue&type=script&lang=js"
import style0 from "./FornecedorManage.vue?vue&type=style&index=0&id=52f18aa5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f18aa5",
  null
  
)

export default component.exports